import * as actions from './expenseCategory/actions'
import * as mutations from './expenseCategory/mutations'
import * as getters from './expenseCategory/getters'

import { dataProps } from './expenseCategory/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'category_name',
        sort_direction: 0, 
        search_term: '', 
        search_term_array: [],
        show_all: false
    },
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseCategory.js